import { RootState } from "@/app/stores"
import { IBonusTransactionsAggregates } from "@/shared/api/bonuses"
import { getCommunityStatistics, getCommunityTransactionAggregates, getLatestTransactions, getRegistrationStatistics, ICommunityStatistics, ILatestTransaction, IRegistrationStatistics } from "@/shared/api/community"
import { getUsers, IGetUsersResults, IUser } from "@/shared/api/users"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

export const fetchCommunityStatistics = createAsyncThunk<
    ICommunityStatistics,
    void,
    { state: RootState }
>('communityStatistics/fetchCommunityStatistics', async(_, thunkAPI) => {
    try {
        const data = await getCommunityStatistics()
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchCommunityTransactionAggregates = createAsyncThunk<
    IBonusTransactionsAggregates,
    void,
    { state: RootState }
>('communityStatistics/fetchCommunityTransactionAggregates', async(_, thunkAPI) => {
    try {
        const currentDate = new Date()
        const startDate = new Date(currentDate.getFullYear(), 1, 1)
        const data = await getCommunityTransactionAggregates(startDate, currentDate)
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchLatestUsers = createAsyncThunk<
    IGetUsersResults,
    void,
    { state: RootState }
>('communityStatistics/fetchLatestUsers', async(_, thunkAPI) => {
    try {
        const data = await getUsers({
            page: 1,
            limit: 15,
            role_id: "users"
        })
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchRegistrationStatistics = createAsyncThunk<
    IRegistrationStatistics,
    void,
    { state: RootState }
>('communityStatistics/fetchRegistrationStatistics', async(_, thunkAPI) => {
    try {
        const currentDate = new Date()
        const startDate = new Date(currentDate.getFullYear(), 1, 1)
        const data = await getRegistrationStatistics(startDate, currentDate)
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchLatestTransactions = createAsyncThunk<
    ILatestTransaction[],
    void,
    { state: RootState }
>('communityStatistics/fetchLatestTransactions', async(_, thunkAPI) => {
    try {
        const data = await getLatestTransactions()
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})